import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Legal.css";

function WaitlistAdmin() {
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    const waitlistEmails = JSON.parse(
      localStorage.getItem("waitlistEmails") || "[]"
    );
    console.log("Loading emails from localStorage:", waitlistEmails);
    console.log("Total emails found:", waitlistEmails.length);
    setEmails(waitlistEmails);
  }, []);

  const clearAll = () => {
    if (
      window.confirm(
        "Are you sure you want to clear all waitlist emails? This cannot be undone."
      )
    ) {
      localStorage.removeItem("waitlistEmails");
      setEmails([]);
    }
  };

  const exportCSV = () => {
    const csv = [
      ["Email", "Type", "Timestamp"],
      ...emails.map((entry) => [
        entry.email,
        entry.type,
        new Date(entry.timestamp).toLocaleString(),
      ]),
    ]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `m31v1-waitlist-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
  };

  return (
    <div className="legal-page">
      <Link to="/" className="back-home">
        ← Back to Home
      </Link>
      <div className="legal-content">
        <h1 className="legal-title">Waitlist Admin</h1>

        <p className="legal-subtitle">Total Signups: {emails.length}</p>

        {emails.length > 0 && (
          <div style={{ marginBottom: "30px", textAlign: "center" }}>
            <button
              onClick={exportCSV}
              style={{
                background: "linear-gradient(135deg, #87CEEB 0%, #4A9FD8 100%)",
                color: "#000",
                fontWeight: "600",
                padding: "12px 24px",
                fontSize: "14px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                marginRight: "10px",
              }}
            >
              Export to CSV
            </button>
            <button
              onClick={clearAll}
              style={{
                background: "rgba(255, 100, 100, 0.2)",
                color: "#ff6666",
                fontWeight: "600",
                padding: "12px 24px",
                fontSize: "14px",
                border: "1px solid #ff6666",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Clear All
            </button>
          </div>
        )}

        {emails.length === 0 ? (
          <p style={{ textAlign: "center", color: "rgba(255,255,255,0.6)" }}>
            No waitlist signups yet.
          </p>
        ) : (
          <div
            style={{
              background: "rgba(255,255,255,0.05)",
              borderRadius: "8px",
              padding: "20px",
              overflowX: "auto",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                color: "#fff",
              }}
            >
              <thead>
                <tr style={{ borderBottom: "2px solid rgba(135,206,235,0.3)" }}>
                  <th style={{ padding: "12px", textAlign: "left" }}>Email</th>
                  <th style={{ padding: "12px", textAlign: "left" }}>Type</th>
                  <th style={{ padding: "12px", textAlign: "left" }}>Date</th>
                </tr>
              </thead>
              <tbody>
                {emails
                  .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                  .map((entry, index) => (
                    <tr
                      key={index}
                      style={{
                        borderBottom: "1px solid rgba(255,255,255,0.1)",
                      }}
                    >
                      <td style={{ padding: "12px", color: "#87CEEB" }}>
                        {entry.email}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          textTransform: "capitalize",
                        }}
                      >
                        {entry.type}
                      </td>
                      <td style={{ padding: "12px", fontSize: "14px" }}>
                        {new Date(entry.timestamp).toLocaleString()}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        <div
          style={{
            marginTop: "40px",
            fontSize: "14px",
            color: "rgba(255,255,255,0.6)",
          }}
        >
          <p>
            <strong>Note:</strong> These emails are currently stored in your
            browser's localStorage. To permanently store them, you can integrate
            with services like:
          </p>
          <ul style={{ marginLeft: "20px" }}>
            <li>
              <a
                href="https://formspree.io"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#87CEEB" }}
              >
                Formspree
              </a>{" "}
              (Free tier available)
            </li>
            <li>
              <a
                href="https://emailjs.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#87CEEB" }}
              >
                EmailJS
              </a>{" "}
              (Free tier available)
            </li>
            <li>
              <a
                href="https://mailchimp.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#87CEEB" }}
              >
                Mailchimp
              </a>{" "}
              (Email marketing)
            </li>
            <li>
              <a
                href="https://airtable.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#87CEEB" }}
              >
                Airtable
              </a>{" "}
              (Spreadsheet database)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default WaitlistAdmin;
